import React, { useState, useEffect, useContext } from 'react'
import { Modal, ModalHeader, ModalFooter, ModalBody, Button, Col, Input, Row, Spinner, Card, CardBody } from 'reactstrap'
import { useSelector } from 'react-redux';
import { UserContext } from './../../../context/context'
import "../../../assets/scss/plugins/extensions/toastr.scss"
import "react-toggle/style.css"
import "react-toastify/dist/ReactToastify.css"
import "../../../assets/scss/plugins/extensions/toastr.scss"
import { toast, ToastContainer } from "react-toastify";
import relojArena from "../../../assets/img/gif/reloj-de-arena.gif"
import codigo from "../../../assets/img/gif/codigo.gif"
import API from '../../../providers/api';
import moment from 'moment';
import { set } from 'lodash';


export const ModalRequestToken = ({ showModal, setShowModal, nameUserSendToken, userEmailSendToken, idToken }) => {
    const {active_token, use_token, name, email, id} = JSON.parse(sessionStorage.getItem('user'))
    const hostName = window.location.hostname
    const { isSocket, requestToken, setRequestToken } = useContext(UserContext)

    const [userEmailToken, setUserEmailToken] = useState('');
    const [token, setToken] = useState('');
    const [loadingRequestToken, setLoadingRequestToken] = useState(false);

    useEffect(() => {
        buscarUsuarioActiveToken()
    }, []);

    useEffect(() => {
        return () => {
            console.log("proceso de token finalizado...")
        }
    }, [requestToken])

    const buscarUsuarioActiveToken = () => {
        API.listusersAll()
        .then(data => data.json())
        .then(dataJson => {
            if (dataJson.success === true) {
                const validarToken = dataJson.data.find(a => a.active_token == true)
                if(validarToken != undefined){
                    setUserEmailToken(validarToken.email)
                }else{
                    toast.error('No hay un usuario configurado que genere el TOKEN, contacte con el administrador')
                    setShowModal(false)
                }
            }else{
                toast.warn('No hay un usuario configurado que genere el TOKEN, contacte con el administrador')
                setShowModal(false)
            }
        })
        .catch((e) => {
            console.log("Ups! Ha sucedio algo >>>", e)
        })
    }

    const enviarToken = () => {
        if(idToken == undefined || idToken == "")
            return toast.warn("Se requiere el ID del TOKEN")
        if(token == "")
            return toast.warn("Se requiere el dato del TOKEN")

        API.actualizarToken(idToken, id, token)
        .then(data => data.json())
        .then(dataJson => {
            if (dataJson.success === true) {
                toast.success(dataJson.message)
                setShowModal(false)
                setLoadingRequestToken(true)
                isSocket.send(JSON.stringify(
                    {
                        "process": "enviar-token",
                        "email": userEmailSendToken,
                        "token": token,
                        "project": hostName
                    }
                ));
            }else{
                toast.warn(dataJson.message)
            }
        })
        .catch((e) => {
            console.log("Ups! Ha sucedio algo >>>", e)
        })
    }

    const solicitarToken = () => {
        //Se valida si hay un token en espera de respuesta
        API.verificarToken()
        .then(data => data.json())
        .then(dataJson => {
            if (dataJson.success === true) {
                API.agregarToken(id)
                .then(data2 => data2.json())
                .then(dataJson2 => {
                    if (dataJson2.success === true) {
                        setLoadingRequestToken(true)
                        isSocket.send(JSON.stringify(
                            {
                                "process": "solicitar-token",
                                "userSend": name,
                                "emailUserSend": email,//Usuario que envia la solicitud
                                "emailUserRecive": userEmailToken,//Usuario que tiene configurado el TOKEN
                                "message": 'solicitar',
                                "project": hostName,
                                "idToken": dataJson2.data.id
                            }
                        ));
                    }else{
                        toast.warn(dataJson.message)
                    }
                })
                .catch((e) => {
                    console.log("Ups! Ha sucedio algo >>>", e)
                })
            }else{
                setShowModal(false)
                toast.warn(dataJson.message)
            }
        })
        .catch((e) => {
            console.log("Ups! Ha sucedio algo >>>", e)
        })
    }

    const cerrarModal = () => {
        setShowModal(false)
        setToken('')
        setLoadingRequestToken(false)
        setRequestToken('')
    }

    const handleKeyPress = (event) => {
        console.log("first")
        if (event.key === 'Enter') {
            enviarToken()
        }
    };

return (
    <>
    <Modal isOpen={showModal}>
        <ModalHeader>
            Solicitud de TOKEN
        </ModalHeader>
        <ModalBody>
            {
                active_token != undefined && active_token === true ?
                <>
                    <Row>
                        <Col>
                            <h5>El usuario {nameUserSendToken?.toUpperCase()} ha solicitado un TOKEN</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <labe>Digite el TOKEN</labe>
                            <Input value={token} onChange={e => setToken(e.target.value)} onKeyDown={handleKeyPress} />
                        </Col>
                        <Col>
                            <br/>
                            {
                                loadingRequestToken == false ?
                                <Button color="success" onClick={enviarToken}>Enviar</Button>
                                :
                                <Button color="success" disabled>Enviando...</Button>
                            }
                        </Col>
                    </Row>
                </>
                :
                use_token != undefined && use_token === true ?
                <Row>
                    {
                        requestToken != undefined && requestToken != "" ?
                        <Col className='text-center'>
                            <h5>Se ha generado el siguiente TOKEN </h5><br/>
                            <Card style={{ borderRadius: '15px', border: '3px solid #28C76F' }}>
                                <CardBody>
                                    <img src={codigo} style={{ width: '20%' }} alt="Código" />
                                </CardBody>
                                <p className="card-text display-4 text-center">{requestToken}</p>
                            </Card>
                            <h5 outline>{}</h5>
                        </Col>
                        :
                        loadingRequestToken == false ?
                        <Col className='text-center'>
                            <h5>No se ha generado TOKEN</h5>
                            <Button color="success" onClick={()=>solicitarToken()}>Solicitar TOKEN</Button>
                        </Col>
                        :
                        <Col className='text-center'>
                            <h5>Por favor, espere mientras recibe el TOKEN</h5>
                            <img src={relojArena} alt="relog-arena" className="img-center" style={{width:'20%'}} />
                        </Col>
                    }
                </Row>
                : <Row>
                    <Col>
                        <h5>Ud no tiene permisos para solicitar un token</h5>
                    </Col>
                </Row>
            }
        </ModalBody>
        <ModalFooter>
            {
                use_token != undefined && use_token === true ?
                    requestToken != undefined && requestToken != "" &&
                        <Button outline color="info" onClick={()=>cerrarModal()}>Cerrar</Button>
                : active_token != undefined && active_token === true &&
                    <Button outline color="info" onClick={()=>cerrarModal()}>Cerrar</Button>
            }
        </ModalFooter>
    </Modal>
    </>
)
}
